import { track } from "@vercel/analytics";

export type AnalyticsEvent =
  | "cta_click"
  | "contact_submit"
  | "contact_result"
  | "assistant_ask"
  | "assistant_cta_shown"
  | "assistant_open"
  | "portfolio_open"
  | "case_study_open"
  | "case_study_cta_click"
  | "book_call_open"
  | "booking_started"
  | "booking_confirmed"
  | "package_card_cta"
  | "package_details_open"
  | "package_page_view"
  | "insight_open"
  | "insight_related_click"
  | "insight_cta_click"
  | "newsletter_submit"
  | "newsletter_result"
  | "estimator_open"
  | "estimator_step"
  | "estimator_complete"
  | "estimator_cta"
  | "built_by_agents_view"
  | "built_by_agents_cta_click"
  | "faq_view"
  | "faq_cta_click"
  | "faq_question_expand"
  | "case_study_demo_run"
  | "case_study_demo_fallback";

const PII_MAX_LEN = 32;
const PII_PATTERN = /@/;

function stripPii(props: Record<string, string>): Record<string, string> {
  const clean: Record<string, string> = {};
  for (const [k, v] of Object.entries(props)) {
    if (v.length <= PII_MAX_LEN && !PII_PATTERN.test(v)) {
      clean[k] = v;
    }
  }
  return clean;
}

export function trackEvent(
  name: AnalyticsEvent,
  props?: Record<string, string>
): void {
  if (typeof window === "undefined") return;
  try {
    track(name, props ? stripPii(props) : undefined);
  } catch {
    // analytics must never break the page
  }
}
